/** Email Header — document knowledge definition. Pure data. */
export default {
  id: 'email-header',
  name: 'Email Header',
  description: 'The banner image that opens a marketing or transactional email.',
  purpose: 'Email Branding & Campaigns',
  recommendedSizes: [{ name: 'Email Header', width: 1200, height: 400, unit: 'px' }],
  supportedOrientations: ['landscape'],
  supportsMultiplePages: false,
  supportsBleed: false,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: false,
  supportsTables: false,
  supportsPricing: false,
  supportsCTA: true,
  supportsOffers: true,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Logo', 'Headline', 'Visual', 'CTA'],
};
